// components/search/Search.tsx
"use client";
// Search — SearchInner'ı Suspense ile sarar.
// Bu wrapper Suspense gerektirmez → anında render edilir, arama kutusu
// sayfa yüklendiğinde hemen görünür, hydration/useSearchParams sync'ini
// beklemez.
import { Suspense } from "react";
import SearchInner from "./more/SearchInner";
import SearchInputSkeleton from "./more/SearchInputSkeleton";

interface SearchProps {
  /** Fotoğrafla ara modalı açılmadan hemen önce çağrılır — mobil sidebar gibi
   *  Search'ün içinde bulunduğu üst katmanı (z-index çakışmasını önlemek için) kapatmak isteyenler kullanır. */
  onPhotoSearchOpen?: () => void;
}

const Search = ({ onPhotoSearchOpen }: SearchProps) => (
  <Suspense fallback={<SearchInputSkeleton />}>
    <SearchInner onPhotoSearchOpen={onPhotoSearchOpen} />
  </Suspense>
);

export default Search;
